import banner from "./banner";

const marketingModule = {
  namespaced: true,
  modules: {
    banner,
  },
};

export default marketingModule;
